export const WORKING_STATUS_FADE_MS = 320;
